import { useContext } from 'react';
import { QuotaContext, type QuotaContextValue } from './quotaContext';

/** This month's generation allowance. Requires `QuotaProvider`. */
export function useQuota(): QuotaContextValue {
  const value = useContext(QuotaContext);
  if (!value) {
    throw new Error('useQuota must be used inside QuotaProvider.');
  }
  return value;
}
